import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvestmentInCompaniesService } from './investment-incompanies.service';
import { InvestmentInCompaniesListComponent } from './investment-incompanies-list.component';

@Component({
    selector: 'convfact-investmentincompaniesdelete',
    templateUrl: './investment-incompanies-dialog-delete.component.html',
    styleUrls: ['./investment-incompanies.component.css'],
    standalone: false
})
export class InvestmentInCompaniesDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<InvestmentInCompaniesListComponent>,
    public investmentInCompaniesService: InvestmentInCompaniesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.investmentInCompaniesService.delete(this.uid)
      .then(res => {
        this.response_message = "Se ha eliminado correctamente la inversión";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la inversión";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
